/* eslint-disable no-unused-vars */
import { createRouter, createWebHistory } from "vue-router";
import store from "@/store";
import RootPage from "@/RootPage";
import * as Cookies from "js-cookie";

const routes = [
  {
    path: "/",
    name: "RootPage",
    component: RootPage,
    children: [
      {
        path: "/dashboard",
        name: "dashboard",
        component: () =>
          import(/* webpackChunkName: "dashboard" */ "@/Pages/Dashboard.vue")
      }
    ]
  },
  {
    path: "/giris",
    name: "login",
    component: () =>
      import(/* webpackChunkName: "login" */ "@/Pages/Login/Login.vue")
  },
  {
    path: "/hesap-yonetimi",
    name: "hesapyonetimi",
    component: RootPage,
    children: [
      {
        path: "",
        name: "hesapyonetimiana",
        // Authorizations.Type = 0 (Hesap Yönetimi)
        meta: { id: 0 },
        component: () =>
          import(
            /* webpackChunkName: "hesapyonetimi" */ "@/Pages/Ayarlar/PageKullanicilar.vue"
          )
      },
      {
        path: "ozellik-tanimlari",
        name: "ozelliktanimlari",
        // Authorizations.Type = 9 (Dinamik Özellikler)
        meta: { id: 9 },
        component: () =>
          import(
            /* webpackChunkName: "ozelliktanimlari" */ "@/Pages/Ayarlar/PageOzellikTanimlari.vue"
          )
      }
    ]
  },
  {
    path: "/sorular",
    name: "sorular",
    component: RootPage,
    children: [
      {
        path: "liste",
        name: "soruliste",
        // Authorizations.Type = 1 (Soru Listesi)
        meta: { id: 1 },
        component: () =>
          import(
            /* webpackChunkName: "sorular" */ "@/Pages/Sorular/PageSorular.vue"
          )
      },
      {
        path: "arsiv",
        name: "soruarsiv",
        // Authorizations.Type = 10 (Soru Arşiv)
        meta: { id: 10 },
        component: () =>
          import(
            /* webpackChunkName: "sorular" */ "@/Pages/Sorular/PageSoruArsiv.vue"
          )
      },
      {
        path: "kategoriler",
        name: "sorukategori",
        // Authorizations.Type = 2 (Kategoriler)
        meta: { id: 2 },
        component: () =>
          import(
            /* webpackChunkName: "sorular" */ "@/Pages/Sorular/PageKategoriler.vue"
          )
      }
    ]
  },
  {
    path: "/referanslar",
    name: "referanslar",
    component: RootPage,
    children: [
      {
        path: "liste",
        name: "referansliste",
        // Authorizations.Type = 3 (Referans Listesi)
        meta: { id: 3 },
        component: () =>
          import(
            /* webpackChunkName: "referansliste" */ "@/Pages/Referanslar/PageReferanslar.vue"
          )
      },
      {
        path: "video-referanslar",
        name: "videoReferanslar",
        meta: { id: 3 },
        component: () =>
          import(
            /* webpackChunkName: "videoReferanslar" */ "@/Pages/Referanslar/PageVideoReferanslar.vue"
          )
      },
      {
        path: "soru/:id",
        name: "sorureferanslari",
        meta: { id: 3 },
        component: () =>
          import(
            /* webpackChunkName: "referansliste" */ "@/Pages/Referanslar/PageSoruReferans.vue"
          )
      },
      {
        path: "ekle/:id/:nid",
        name: "referansekle",
        meta: { id: 3 },
        component: () =>
          import(
            /* webpackChunkName: "referansliste" */ "@/Pages/Referanslar/PageReferansEkle.vue"
          )
      },
      {
        path: "duzenle/:id",
        //path: 'duzenle/:id/:nid',
        name: "referansduzenle",
        meta: { id: 3 },
        component: () =>
          import(
            /* webpackChunkName: "referansliste" */ "@/Pages/Referanslar/PageReferansEkle.vue"
          )
      }
    ]
  },
  {
    path: "/ders-notlari",
    name: "dersnotlari",
    component: RootPage,
    // Authorizations.Type = 4 (Ders Notları)
    meta: { id: 4 },
    children: [
      {
        path: "",
        name: "dersnotlariliste",
        meta: { id: 4 },
        component: () =>
          import(
            /* webpackChunkName: "dersnotlari" */ "@/Pages/Referanslar/PageDersNotlari.vue"
          )
      }
    ]
  },
  {
    path: "/ders-notu-ata",
    name: "dersnotuata",
    component: RootPage,
    // Authorizations.Type = 5 (Ders Notu Ata)
    meta: { id: 5 },
    children: [
      {
        path: "/ders-notu-ata",
        name: "dersnotuatalist",
        meta: { id: 5 },
        component: () =>
          import(
            /* webpackChunkName: "dersnotuata" */ "@/Pages/Referanslar/PageDersNotuAta.vue"
          )
      }
    ]
  },
  {
    path: "/loglar",
    name: "loglar",
    component: RootPage,
    // Authorizations.Type = 6 (Loglar)
    meta: { id: 6 },
    children: [
      {
        path: "",
        name: "loglarlist",
        meta: { id: 6 },
        component: () =>
          import(
            /* webpackChunkName: "loglar" */ "@/Pages/Referanslar/PageLoglar.vue"
          )
      }
    ]
  },
  {
    path: "/export",
    name: "export",
    component: RootPage,
    // Authorizations.Type = 8 (Export)
    meta: { id: 8 },
    children: [
      {
        path: "",
        name: "exportlist",
        meta: { id: 8 },
        component: () =>
          import(
            /* webpackChunkName: "export" */ "@/Pages/Export/PageExport.vue"
          )
      },
      {
        path: "pdf-renk-ayarlari",
        name: "pdfrenkayarlari",
        meta: { id: 8 },
        component: () =>
          import(
            /* webpackChunkName: "export" */ "@/Pages/Export/PagePdfColorSettings.vue"
          )
      }
    ]
  },
  {
    path: "/sinav-yorumlari",
    name: "sinavyorumlari",
    component: RootPage,
    // Authorizations.Type = 7 (Sınav Yorumları / Loglar)
    meta: { id: 7 },
    children: [
      {
        path: "",
        name: "sinavyorumlarilist",
        meta: { id: 7 },
        component: () =>
          import(
            /* webpackChunkName: "sinavyorumlari" */ "@/Pages/Referanslar/PageSinavYorumlari.vue"
          )
      }
    ]
  },
  {
    path: "/dev",
    name: "dev",
    component: RootPage,
    meta: { id: 9 },
    children: [
      {
        path: "filter-bar-test",
        name: "filterbartest",
        meta: { id: 9 },
        component: () =>
          import(
            /* webpackChunkName: "dev-filterbar" */ "@/Pages/Dev/PageFilterBarTest.vue"
          )
      }
    ]
  },
  {
    path: "/yorumlar",
    name: "yorumlar",
    component: RootPage,
    meta: { id: 7 },
    children: [
      {
        path: "",
        name: "yorumlarlist",
        meta: { id: 7 },
        component: () =>
          import(
            /* webpackChunkName: "yorumlar" */ "@/Pages/Referanslar/PageYorumlar.vue"
          )
      }
    ]
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { top: 0, "scroll-behavior": "smooth" };
  }
});
router.beforeEach(async (to, from, next) => {
  // Login her zaman serbest
  if (to.path === "/giris") return next();

  // Yetki kontrolü code (a0, a1, a3 vb.) üzerinden; meta.code veya meta.id'den türetilir
  const meta = (to.matched && to.matched.length
    ? [...to.matched].reverse().find(r => r.meta && (r.meta.code != null || r.meta.id != null))?.meta
    : to.meta) ?? {};
  const requiredCode = meta.code ?? (meta.id != null ? "a" + meta.id : null);

  if (requiredCode == null) return next();

  if (store.state.userid == null) {
    try {
      await store.dispatch("authControl");
    } catch {
      // authControl zaten /giris'e yönlendiriyor
    }
  }

  const isSuper =
    Array.isArray(store.state.supers) &&
    store.state.supers.indexOf(store.state.userrole) >= 0;
  const hasAuth =
    Array.isArray(store.state.userauthCodes) &&
    store.state.userauthCodes.includes(requiredCode);

  if (isSuper || hasAuth) return next();

  // Yetkisiz: dashboard'a dön
  if (to.path !== "/dashboard") return next("/dashboard");
  return next();
});
export default router;
